import React from "react";
import { useParams, Navigate } from "react-router-dom";
import Header from "../components/Header";
import Breadcrumb from "../components/Breadcrumb";
import CompanyHeader from "../components/CompanyHeader";
import CompanyDetails from "../components/CompanyDetails";
import OverviewSection from "../components/OverviewSection";
import CollectiveComplaint from "../components/CollectiveComplaint";
import ReviewsList from "../components/ReviewsList";
import SimilarCompanies from "../components/SimilarCompanies";
import Footer from "../components/Footer";
import { CompanyProvider } from "../context/CompanyContext";
import { getCompanyBySlug } from "../data/companies";
import { REVIEWS_BY_SLUG } from "../data/reviews";

export default function ReviewsPage() {
  const params = useParams();
  const slug = params.slug;
  const company = getCompanyBySlug(slug);
  const reviews = REVIEWS_BY_SLUG[slug] || [];

  React.useEffect(() => {
    if (!company) return;
    const prev = document.title;
    document.title = `${company.name} Reviews | ReviewUK`;
    return () => { document.title = prev; };
  }, [company]);

  if (!company) {
    return <Navigate to="/" replace />;
  }

  const breadcrumbTrail = [
    { label: "Home", to: "/" },
    {
      label: company.breadcrumbCategory?.[0] || company.category,
      to: company.breadcrumbCategory?.[1] || "/",
    },
    { label: company.name, to: `/company/${slug}` },
    { label: "Reviews" },
  ];

  return (
    <CompanyProvider value={{ company, reviews }}>
      <div className="min-h-screen bg-[#f5f7f8] font-[Inter,system-ui,-apple-system,sans-serif]">
        <Header />
        <Breadcrumb trail={breadcrumbTrail} />
        <CompanyHeader />

        <div className="bg-[#f5f7f8] border-b border-gray-200">
          <div className="max-w-[1200px] mx-auto px-4 py-2 text-[10px] uppercase tracking-wider text-gray-400 text-center">
            Advertisements
          </div>
        </div>

        <CompanyDetails />
        <OverviewSection />
        <CollectiveComplaint />

        <main className="bg-[#f5f7f8]">
          <div className="max-w-[1200px] mx-auto px-4 pb-8" id="reviews">
            <ReviewsList />
          </div>
        </main>

        <SimilarCompanies />
        <Footer />
      </div>
    </CompanyProvider>
  );
}
